export default class LocationsService {

  constructor(Restangular) {
    'ngInject';
    this.Restangular = Restangular;
  }

  save(location) {
    let promise;
    if (location.key !== undefined) {
      promise = location.put();
    } else {
      promise = this.Restangular.service('locations').post(location);
    }
    return promise;
  }

  searchAllTenantLocationsByName(tenantId, customerLocationName) {
    let promise = this.Restangular.all('tenants').customGETLIST(tenantId + "/locations", {customerLocationName: customerLocationName})
    return promise;
  }

  getLocationsBytenantId(tenantId) {
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/locations?all=true`).get();
    return promise;
  }

  getLocationsBytenantIdPaginated(tenantId, page) {
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/locations?page=${page}`).get();
    return promise;
  }

  getLocationById(locationId) {
    let promise = this.Restangular.oneUrl('locations', `${process.env.__backendUrl__}/internal/v1/locations/${locationId}`).get();
    return promise;
  }
}
